import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CancelBatchEnrollmentBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const cancelEducationalAdvisorBatchEnrollment = createApiThunk<void, CancelBatchEnrollmentBody>(
  "educationalAdvisor/cancelBatchEnrollment",
  async (command, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.cancelEnrollment(command);
  },
);

export const resetCancelEducationalAdvisorBatchEnrollment = createAction("educationalAdvisor/resetCancelBatchEnrollment");
